import { pdpSharedNotifications } from '../PdpSharedNotifications/pdpSharedNotifications.js';

export const pdpRespNotifications = [...pdpSharedNotifications];
